import { IMG_SPINNER } from "../../../utils/url/staticResources";
import classes from "./CircleSpinner.module.less";
import classNames from "classnames";

interface SpinnerProps {
  className?: string;
}

const CircleSpinner = (props: SpinnerProps) => {
  return <img className={classNames(classes.root, props.className)} src={IMG_SPINNER} />;
};

export default CircleSpinner;
